export default __webpack_public_path__ + "static/media/MusicalIntruments_38.5269d362.png";